import React, { useState, useEffect, useMemo, useMapEvent, useCallback, MouseEvent  }  from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip, Circle, CircleMarker, GeoJSON } from 'react-leaflet'
import { Modal, Tag, Select, Space, Row, Col } from "antd"
import dayjs from 'dayjs';
import { DingdingOutlined } from '@ant-design/icons';
import Mongolian_map from "./Mongolian_map.json"
import Population from "./mn_population.json"
const data =[
  {
    "syn_id": "44374",
    "id": "43201000",
    "aimag": "Өмнөговь",
    "sum": "Гурвантэс",
    "start_obs_date": "6/1/1970 0:00",
    "lat": "43.3864",
    "lon": "101.0736",
    "hhh": "1721",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01432010101ГУРВАНТЭС",
    "presona_code": "4320101",
    "type_string": "станц",
    "station_name": "Гурвантэс"
  },
  {
    "syn_id": "44385",
    "id": "43207200",
    "aimag": "Өмнөговь",
    "sum": "Ханбогд",
    "start_obs_date": "2/1/1965 0:00",
    "lat": "43.1957",
    "lon": "107.1935",
    "hhh": "1109",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01432072101ХАНБОГД",
    "presona_code": "4320721",
    "type_string": "станц",
    "station_name": "Ханбогд"
  },
  {
    "syn_id": "44366",
    "id": "43299000",
    "aimag": "Баянхонгор",
    "sum": "Жинст",
    "start_obs_date": "12/1/1979 0:00",
    "lat": "43.40147",
    "lon": "99.00273",
    "hhh": "970",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01432990001ЭХИЙНГОЛ",
    "presona_code": "4329900",
    "type_string": "станц",
    "station_name": "Эхийнгол"
  },
  {
    "syn_id": "44373",
    "id": "43604400",
    "aimag": "Өмнөговь",
    "sum": "Даланзадгад",
    "start_obs_date": "10/1/1936 0:00",
    "lat": "43.5772",
    "lon": "104.4181",
    "hhh": "1462",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01436044101ДАЛАНЗАДГАД",
    "presona_code": "4360441",
    "type_string": "станц",
    "station_name": "Даланзадгад"
  },
  {
    "syn_id": "44386",
    "id": "43609600",
    "aimag": "Дорноговь",
    "sum": "Хөвсгөл",
    "start_obs_date": "1/1/1965 0:00",
    "lat": "43.6045",
    "lon": "109.6362",
    "hhh": "998.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01436096101ХӨВСГӨЛ",
    "presona_code": "4360961",
    "type_string": "станц",
    "station_name": "Хөвсгөл"
  },
  {
    "syn_id": "44358",
    "id": "43711900",
    "aimag": "Дорноговь",
    "sum": "Замын-Үүд",
    "start_obs_date": "10/24/1955 0:00",
    "lat": "43.7025",
    "lon": "111.9008",
    "hhh": "963.9",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01437119101ЗАМЫН-YYД",
    "presona_code": "4371191",
    "type_string": "станц",
    "station_name": "Замын-Үүд"
  },
  {
    "syn_id": "44339",
    "id": "44103600",
    "aimag": "Өмнөговь",
    "sum": "Булган",
    "start_obs_date": "3/1/1961 0:00",
    "lat": "44.0961",
    "lon": "103.5369",
    "hhh": "1291",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01441036101САЙХАН",
    "presona_code": "4410361",
    "type_string": "станц",
    "station_name": "Сайхан"
  },
  {
    "syn_id": "44382",
    "id": "44106800",
    "aimag": "Өмнөговь",
    "sum": "Манлай",
    "start_obs_date": "1/1/1963 0:00",
    "lat": "44.1388",
    "lon": "107.4489",
    "hhh": "1300",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01441068101МАНЛАЙ",
    "presona_code": "4410681",
    "type_string": "станц",
    "station_name": "Манлай"
  },
  {
    "syn_id": "44347",
    "id": "44405300",
    "aimag": "Өмнөговь",
    "sum": "Цогт-Овоо",
    "start_obs_date": "7/1/1962 0:00",
    "lat": "44.4232",
    "lon": "105.3168",
    "hhh": "1291",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01444053101ЦОГТ-ОВОО",
    "presona_code": "4440531",
    "type_string": "станц",
    "station_name": "Цогт-Овоо"
  },
  {
    "syn_id": "44348",
    "id": "44408800",
    "aimag": "Дорноговь",
    "sum": "Мандах",
    "start_obs_date": "1/1/1963 0:00",
    "lat": "44.4014",
    "lon": "108.2493",
    "hhh": "1308.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01444088101МАНДАХ",
    "presona_code": "4440881",
    "type_string": "станц",
    "station_name": "Мандах"
  },
  {
    "syn_id": "44357",
    "id": "44411100",
    "aimag": "Дорноговь",
    "sum": "Улаан-Уул",
    "start_obs_date": "1/10/1992 0:00",
    "lat": "44.4438",
    "lon": "111.086",
    "hhh": "992",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "2013 оны 5 сараас станц болсон",
    "presona_register": "01444111101УЛААН-УУЛ",
    "presona_code": "4441111",
    "type_string": "станц",
    "station_name": "Улаан-Уул"
  },
  {
    "syn_id": "44329",
    "id": "44599300",
    "aimag": "Баянхонгор",
    "sum": "Жинст",
    "start_obs_date": "12/1/1972 0:00",
    "lat": "44.5156",
    "lon": "99.1055",
    "hhh": "2229",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01445993001ЖИНСТ",
    "presona_code": "4459930",
    "type_string": "станц",
    "station_name": "Жинст"
  },
  {
    "syn_id": "44289",
    "id": "44604100",
    "aimag": "Өвөрхангай",
    "sum": "Баян-Өндөр",
    "start_obs_date": "11/2/1962 0:00",
    "lat": "46.4981",
    "lon": "104.112",
    "hhh": "1627",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "02446041101БАЯН-ӨНДӨР",
    "presona_code": "4460411",
    "type_string": "станц",
    "station_name": "Баян-Өндөр"
  },
  {
    "syn_id": "44338",
    "id": "44702200",
    "aimag": "Өвөрхангай",
    "sum": "Богд",
    "start_obs_date": "7/22/1965 0:00",
    "lat": "44.6741",
    "lon": "102.1755",
    "hhh": "1522",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01447022101БОГД",
    "presona_code": "4470221",
    "type_string": "станц",
    "station_name": "Богд"
  },
  {
    "syn_id": "44337",
    "id": "44800300",
    "aimag": "Баянхонгор",
    "sum": "Баянговь",
    "start_obs_date": "10/1/2013 0:00",
    "lat": "44.7479",
    "lon": "100.3993",
    "hhh": "1612",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "2013 оны 10 сараас станц болсон",
    "presona_register": "01448003101БАЯНГОВЬ",
    "presona_code": "4480031",
    "type_string": "станц",
    "station_name": "Баянговь"
  },
  {
    "syn_id": "44354",
    "id": "44910100",
    "aimag": "Дорноговь",
    "sum": "Сайншанд",
    "start_obs_date": "10/18/1938 0:00",
    "lat": "44.8678",
    "lon": "110.117",
    "hhh": "937.9",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01449101101САЙНШАНД",
    "presona_code": "4491011",
    "type_string": "станц",
    "station_name": "Сайншанд"
  },
  {
    "syn_id": "44324",
    "id": "44995500",
    "aimag": "Говь-Алтай",
    "sum": "Алтай",
    "start_obs_date": "11/18/1983 0:00",
    "lat": "44.6192",
    "lon": "94.9237",
    "hhh": "1425",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01449955001АЖБОГД",
    "presona_code": "4499550",
    "type_string": "станц",
    "station_name": "Ажбогд"
  },
  {
    "syn_id": "44325",
    "id": "44996800",
    "aimag": "Говь-Алтай",
    "sum": "Цогт",
    "start_obs_date": "8/22/1959 0:00",
    "lat": "44.924",
    "lon": "96.7533",
    "hhh": "1179",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01449968001ТООРОЙ",
    "presona_code": "4499680",
    "type_string": "станц",
    "station_name": "Тоорой"
  },
  {
    "syn_id": "44326",
    "id": "45098900",
    "aimag": "Баянхонгор",
    "sum": "Баянцагаан",
    "start_obs_date": "9/16/1973 0:00",
    "lat": "45.012",
    "lon": "98.9333",
    "hhh": "2015",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01450989001БАЯНЦАГААН",
    "presona_code": "4509890",
    "type_string": "станц",
    "station_name": "Баянцагаан"
  },
  {
    "syn_id": "44334",
    "id": "45200800",
    "aimag": "Баянхонгор",
    "sum": "Богд",
    "start_obs_date": "7/25/1969 0:00",
    "lat": "45.1938",
    "lon": "100.7772",
    "hhh": "1274",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01452008101ХОРИУЛТ",
    "presona_code": "4520081",
    "type_string": "станц",
    "station_name": "Хориулт"
  },
  {
    "syn_id": "44331",
    "id": "45201400",
    "aimag": "Өвөрхангай",
    "sum": "Баруунбаян-Улаан",
    "start_obs_date": "5/1/2008 0:00",
    "lat": "45.1783",
    "lon": "101.4133",
    "hhh": "1260",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01452014101БАРУУНБАЯН-УЛААН",
    "presona_code": "4520141",
    "type_string": "станц",
    "station_name": "Баруунбаян-Улаан"
  },
  {
    "syn_id": "44356",
    "id": "45313800",
    "aimag": "Сүхбаатар",
    "sum": "Дарьганга",
    "start_obs_date": "12/1/1964 0:00",
    "lat": "45.3214",
    "lon": "113.8462",
    "hhh": "1246",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "02453138101ДАРЬГАНГА",
    "presona_code": "4531381",
    "type_string": "станц",
    "station_name": "Дарьганга"
  },
  {
    "syn_id": "44336",
    "id": "45403900",
    "aimag": "Дундговь",
    "sum": "Сайхан-Овоо",
    "start_obs_date": "1/1/1967 0:00",
    "lat": "45.4612",
    "lon": "103.9001",
    "hhh": "1316",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01454039101Сайхан-Овоо",
    "presona_code": "4540391",
    "type_string": "станц",
    "station_name": "Сайхан-Овоо"
  },
  {
    "syn_id": "44345",
    "id": "45407000",
    "aimag": "Дундговь",
    "sum": "Гурвансайхан",
    "start_obs_date": "1/1/1984 0:00",
    "lat": "45.5283",
    "lon": "107.0446",
    "hhh": "1165",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01454070101Гурвансайхан",
    "presona_code": "4540701",
    "type_string": "станц",
    "station_name": "Гурвансайхан"
  },
  {
    "syn_id": "44268",
    "id": "45494400",
    "aimag": "Говь-Алтай",
    "sum": "Бугат",
    "start_obs_date": "8/1/1987 0:00",
    "lat": "45.5608",
    "lon": "94.361",
    "hhh": "2147",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01454944001БУГАТ",
    "presona_code": "4549440",
    "type_string": "станц",
    "station_name": "Бугат"
  },
  {
    "syn_id": "44332",
    "id": "45603000",
    "aimag": "Өвөрхангай",
    "sum": "Төгрөг",
    "start_obs_date": "8/1/1995 0:00",
    "lat": "45.5391045",
    "lon": "102.99897",
    "hhh": "1390",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01456030101ТӨГРӨГ",
    "presona_code": "4560301",
    "type_string": "станц",
    "station_name": "Төгрөг"
  },
  {
    "syn_id": "44352",
    "id": "45712400",
    "aimag": "Сүхбаатар",
    "sum": "Баяндэлгэр",
    "start_obs_date": "10/1/1968 0:00",
    "lat": "45.7303",
    "lon": "112.3552",
    "hhh": "1107.8",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "1939-1968-??????? 1969-??? ??????????",
    "presona_register": "01457124101БАЯНДЭЛГЭР",
    "presona_code": "4571241",
    "type_string": "станц",
    "station_name": "Байшинт/Баяндэлгэр"
  },
  {
    "syn_id": "44341",
    "id": "45806300",
    "aimag": "Дундговь",
    "sum": "Мандалговь",
    "start_obs_date": "2/1/1944 0:00",
    "lat": "45.743",
    "lon": "106.2642",
    "hhh": "1393",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01458063101Мандалговь",
    "presona_code": "4580631",
    "type_string": "станц",
    "station_name": "Мандалговь"
  },
  {
    "syn_id": "44351",
    "id": "45811200",
    "aimag": "Дорноговь",
    "sum": "Дэлгэрэх",
    "start_obs_date": "1/1/1993 0:00",
    "lat": "45.7956",
    "lon": "111.2106",
    "hhh": "1064",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01458112101ДЭЛГЭРЭХ",
    "presona_code": "4581121",
    "type_string": "станц",
    "station_name": "Дэлгэрэх"
  },
  {
    "syn_id": "44317",
    "id": "45915400",
    "aimag": "Сүхбаатар",
    "sum": "Эрдэнэцагаан",
    "start_obs_date": "3/1/1938 0:00",
    "lat": "45.9068",
    "lon": "115.372",
    "hhh": "1070",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01459154101ЭРДЭНЭЦАГААН",
    "presona_code": "4591541",
    "type_string": "станц",
    "station_name": "Эрдэнэцагаан"
  },
  {
    "syn_id": "44333",
    "id": "46005000",
    "aimag": "Дундговь",
    "sum": "Эрдэнэдалай",
    "start_obs_date": "11/1/1997 0:00",
    "lat": "45.9987",
    "lon": "104.9382",
    "hhh": "1377",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01460050101Эрдэнэдалай",
    "presona_code": "4600501",
    "type_string": "станц",
    "station_name": "Эрдэнэдалай"
  },
  {
    "syn_id": "44342",
    "id": "46007500",
    "aimag": "Дундговь",
    "sum": "Говь-Угтаал",
    "start_obs_date": "10/1/2013 0:00",
    "lat": "46.0439",
    "lon": "107.4854",
    "hhh": "1481",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "2013 оны 10 сараас станц болсон",
    "presona_register": "02460075101Говь-Угтаал",
    "presona_code": "4600751",
    "type_string": "станц",
    "station_name": "Говь-Угтаал"
  },
  {
    "syn_id": "44287",
    "id": "46100700",
    "aimag": "Баянхонгор",
    "sum": "Баянхонгор",
    "start_obs_date": "10/13/1962 0:00",
    "lat": "46.1738",
    "lon": "100.7102",
    "hhh": "1858",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01461007101БАЯНХОНГОР",
    "presona_code": "4610071",
    "type_string": "станц",
    "station_name": "Баянхонгор"
  },
  {
    "syn_id": "44265",
    "id": "46191600",
    "aimag": "Ховд",
    "sum": "Булган",
    "start_obs_date": "1/1/1963 0:00",
    "lat": "46.0947",
    "lon": "91.5523",
    "hhh": "1184.2",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01461916001Байтаг",
    "presona_code": "4619160",
    "type_string": "станц",
    "station_name": "Байтаг"
  },
  {
    "syn_id": "44307",
    "id": "46210800",
    "aimag": "Хэнтий",
    "sum": "Галшар",
    "start_obs_date": "12/1/1995 0:00",
    "lat": "46.2431",
    "lon": "110.8413",
    "hhh": "1181",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01462108101ГАЛШАР",
    "presona_code": "4621081",
    "type_string": "станц",
    "station_name": "Галшар"
  },
  {
    "syn_id": "44288",
    "id": "46302800",
    "aimag": "Өвөрхангай",
    "sum": "Арвайхээр",
    "start_obs_date": "1/1/1940 0:00",
    "lat": "46.2591",
    "lon": "102.789",
    "hhh": "1815",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01463028101АРВАЙХЭЭР",
    "presona_code": "4630281",
    "type_string": "станц",
    "station_name": "Арвайхээр"
  },
  {
    "syn_id": "44266",
    "id": "46393900",
    "aimag": "Говь-Алтай",
    "sum": "Тонхил",
    "start_obs_date": "7/26/1961 0:00",
    "lat": "46.3128",
    "lon": "93.9018",
    "hhh": "2221",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01463939001ТОНХИЛ",
    "presona_code": "4639390",
    "type_string": "станц",
    "station_name": "Тонхил"
  },
  {
    "syn_id": "44270",
    "id": "46396200",
    "aimag": "Говь-Алтай",
    "sum": "Есөн булаг",
    "start_obs_date": "1/1/1977 0:00",
    "lat": "NULL",
    "lon": "NULL",
    "hhh": "NULL",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "1992 онд хаагдсан",
    "presona_register": "NULL",
    "presona_code": "4639620",
    "type_string": "станц",
    "station_name": "Хантайшир"
  },
  {
    "syn_id": "44300",
    "id": "46407600",
    "aimag": "Дундговь",
    "sum": "Цагаандэлгэр",
    "start_obs_date": "10/1/2009 0:00",
    "lat": "46.4052",
    "lon": "107.6373",
    "hhh": "1364",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01464076101Цагаандэлгэр",
    "presona_code": "4640761",
    "type_string": "станц",
    "station_name": "Цагаандэлгэр"
  },
  {
    "syn_id": "44298",
    "id": "46408200",
    "aimag": "Говьсүмбэр",
    "sum": "Чойр",
    "start_obs_date": "4/1/1956 0:00",
    "lat": "46.3501",
    "lon": "108.3747",
    "hhh": "1286",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01464082101ЧОЙР",
    "presona_code": "4640821",
    "type_string": "станц",
    "station_name": "Чойр"
  },
  {
    "syn_id": "44277",
    "id": "46496200",
    "aimag": "Говь-Алтай",
    "sum": "Есөн булаг",
    "start_obs_date": "9/3/1953 0:00",
    "lat": "46.3762",
    "lon": "96.2387",
    "hhh": "2180",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01464962001АЛТАЙ",
    "presona_code": "4649620",
    "type_string": "станц",
    "station_name": "Алтай"
  },
  {
    "syn_id": "44299",
    "id": "46609400",
    "aimag": "Хэнтий",
    "sum": "Дархан",
    "start_obs_date": "10/1/1983 0:00",
    "lat": "46.6318",
    "lon": "109.4094",
    "hhh": "1273",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01466094101ОРГИЛ",
    "presona_code": "4660941",
    "type_string": "станц",
    "station_name": "Оргил"
  },
  {
    "syn_id": "44271",
    "id": "46693300",
    "aimag": "Ховд",
    "sum": "Цэцэг",
    "start_obs_date": "9/7/1974 0:00",
    "lat": "46.5906",
    "lon": "93.2721",
    "hhh": "1717.2",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01466933001Цэцэг",
    "presona_code": "4669330",
    "type_string": "станц",
    "station_name": "Цэцэг"
  },
  {
    "syn_id": "44284",
    "id": "46700100",
    "aimag": "Баянхонгор",
    "sum": "Галуут",
    "start_obs_date": "11/1/1957 0:00",
    "lat": "46.7021",
    "lon": "100.1428",
    "hhh": "2124",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01467001101ГАЛУУТ",
    "presona_code": "4670011",
    "type_string": "станц",
    "station_name": "Галуут"
  },
  {
    "syn_id": "44305",
    "id": "46713300",
    "aimag": "Сүхбаатар",
    "sum": "Баруун-Урт",
    "start_obs_date": "1/1/1960 0:00",
    "lat": "46.6713",
    "lon": "113.2847",
    "hhh": "976",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01467133101БАРУУН-УРТ",
    "presona_code": "4671331",
    "type_string": "станц",
    "station_name": "Баруун-Урт"
  },
  {
    "syn_id": "44260",
    "id": "46792300",
    "aimag": "Ховд",
    "sum": "Мөнххайрхан",
    "start_obs_date": "10/11/1975 0:00",
    "lat": "47.0654",
    "lon": "91.853",
    "hhh": "2093.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01467923001Мөнххайрхан",
    "presona_code": "4679230",
    "type_string": "станц",
    "station_name": "Мөнххайрхан"
  },
  {
    "syn_id": "44267",
    "id": "46792800",
    "aimag": "Ховд",
    "sum": "Мөст",
    "start_obs_date": "12/25/1962 0:00",
    "lat": "46.6919",
    "lon": "92.7988",
    "hhh": "2027.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01467928001Мөст",
    "presona_code": "4679280",
    "type_string": "станц",
    "station_name": "Мөст"
  },
  {
    "syn_id": "44344",
    "id": "46805900",
    "aimag": "Төв",
    "sum": "Баян-Өнжүүл",
    "start_obs_date": "11/12/1994 0:00",
    "lat": "47.04",
    "lon": "105.9538",
    "hhh": "1213.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01468059101Баян-Өнжүүл",
    "presona_code": "4680591",
    "type_string": "станц",
    "station_name": "Баян-Өнжүүл"
  },
  {
    "syn_id": "44275",
    "id": "46898100",
    "aimag": "Баянхонгор",
    "sum": "Баянбулаг",
    "start_obs_date": "10/16/1977 0:00",
    "lat": "46.8121",
    "lon": "98.0869",
    "hhh": "2257",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01468981001БАЯНБУЛАГ",
    "presona_code": "4689810",
    "type_string": "станц",
    "station_name": "Баянбулаг"
  },
  {
    "syn_id": "44285",
    "id": "46902800",
    "aimag": "Өвөрхангай",
    "sum": "Хужирт",
    "start_obs_date": "10/14/1947 0:00",
    "lat": "46.8998",
    "lon": "102.7788",
    "hhh": "1662",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01469028101ХУЖИРТ",
    "presona_code": "4690281",
    "type_string": "станц",
    "station_name": "Хужирт"
  },
  {
    "syn_id": "44340",
    "id": "46905100",
    "aimag": "Төв",
    "sum": "Бүрэн",
    "start_obs_date": "8/1/1963 0:00",
    "lat": "46.9174",
    "lon": "105.0453",
    "hhh": "1273.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01469051101БYРЭН",
    "presona_code": "4690511",
    "type_string": "станц",
    "station_name": "Бүрэн"
  },
  {
    "syn_id": "44263",
    "id": "46991100",
    "aimag": "Баян-Өлгий",
    "sum": "Булган",
    "start_obs_date": "5/25/1963 0:00",
    "lat": "46.9299",
    "lon": "91.0816",
    "hhh": "1933",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01469911001ДӨЧИНЖИЛ",
    "presona_code": "4699110",
    "type_string": "станц",
    "station_name": "Дөчинжил"
  },
  {
    "syn_id": "44264",
    "id": "47192800",
    "aimag": "Ховд",
    "sum": "Зэрэг",
    "start_obs_date": "9/1/1960 0:00",
    "lat": "47.1081",
    "lon": "92.8373",
    "hhh": "1152",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01471928001Зэрэг",
    "presona_code": "4719280",
    "type_string": "станц",
    "station_name": "Зэрэг"
  },
  {
    "syn_id": "44330",
    "id": "47202800",
    "aimag": "Өвөрхангай",
    "sum": "Хархорин",
    "start_obs_date": "8/10/1965 0:00",
    "lat": "47.1945",
    "lon": "102.8297",
    "hhh": "1478",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01472028101ХАРХОРИН",
    "presona_code": "4720281",
    "type_string": "станц",
    "station_name": "Хархорин"
  },
  {
    "syn_id": "44286",
    "id": "47204200",
    "aimag": "Төв",
    "sum": "Эрдэнэсант",
    "start_obs_date": "2/1/1962 0:00",
    "lat": "47.3515",
    "lon": "104.4918",
    "hhh": "1358.1",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01472042101Эрдэнэсант",
    "presona_code": "4720421",
    "type_string": "станц",
    "station_name": "Эрдэнэсант"
  },
  {
    "syn_id": "44314",
    "id": "47215700",
    "aimag": "Дорнод",
    "sum": "Матад",
    "start_obs_date": "1/1/1975 0:00",
    "lat": "46.9551",
    "lon": "115.2964",
    "hhh": "903.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01472157101МАТАД",
    "presona_code": "4721571",
    "type_string": "станц",
    "station_name": "Матад"
  },
  {
    "syn_id": "44315",
    "id": "47217300",
    "aimag": "Дорнод",
    "sum": "Халхгол",
    "start_obs_date": "1/1/1938 0:00",
    "lat": "47.37",
    "lon": "118.37",
    "hhh": "688",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "1975 онд хаагдсан",
    "presona_register": "NULL",
    "presona_code": "4721731",
    "type_string": "станц",
    "station_name": "Тамсагбулаг"
  },
  {
    "syn_id": "44274",
    "id": "47292600",
    "aimag": "Завхан",
    "sum": "Отгон",
    "start_obs_date": "1/1/1965 0:00",
    "lat": "47.2097",
    "lon": "97.6047",
    "hhh": "2156.1",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01472926001ОТГОН",
    "presona_code": "4729260",
    "type_string": "станц",
    "station_name": "Отгон"
  },
  {
    "syn_id": "44276",
    "id": "47299600",
    "aimag": "Баянхонгор",
    "sum": "Жаргалант",
    "start_obs_date": "5/7/1960 0:00",
    "lat": "47.0165",
    "lon": "99.4794",
    "hhh": "2026",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01472996001БАЙДРАГ",
    "presona_code": "4729960",
    "type_string": "станц",
    "station_name": "Байдраг"
  },
  {
    "syn_id": "44294",
    "id": "47307500",
    "aimag": "Төв",
    "sum": "Баян",
    "start_obs_date": "1/1/1956 0:00",
    "lat": "47.2567",
    "lon": "107.5379",
    "hhh": "1425",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01473075101Мааньт",
    "presona_code": "4730751",
    "type_string": "станц",
    "station_name": "Мааньт"
  },
  {
    "syn_id": "44301",
    "id": "47308700",
    "aimag": "Хэнтий",
    "sum": "Хэрлэнбаян-Улаан",
    "start_obs_date": "1/1/1982 0:00",
    "lat": "47.2136",
    "lon": "108.7377",
    "hhh": "1250",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01473087101ХЭРЛЭНБАЯН-УЛААН",
    "presona_code": "4730871",
    "type_string": "станц",
    "station_name": "Хэрлэнбаян-Улаан"
  },
  {
    "syn_id": "44304",
    "id": "47310700",
    "aimag": "Хэнтий",
    "sum": "Өндөрхаан",
    "start_obs_date": "8/5/1936 0:00",
    "lat": "47.3083",
    "lon": "111.6244",
    "hhh": "1033",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01473107101ӨНДӨРХААН",
    "presona_code": "4731071",
    "type_string": "станц",
    "station_name": "Өндөрхаан"
  },
  {
    "syn_id": "44282",
    "id": "47401500",
    "aimag": "Архангай",
    "sum": "Эрдэнэбулган",
    "start_obs_date": "1/1/1936 0:00",
    "lat": "47.4716",
    "lon": "101.4628",
    "hhh": "1690.6",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01474015101Цэцэрлэг",
    "presona_code": "4740151",
    "type_string": "станц",
    "station_name": "Цэцэрлэг"
  },
  {
    "syn_id": "44001",
    "id": "47408500",
    "aimag": "Төв",
    "sum": "Баяндэлгэр",
    "start_obs_date": "5/1/1942 0:00",
    "lat": "47.42",
    "lon": "108.27",
    "hhh": "1300.4",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "1961.08 хаагдсан",
    "presona_register": "NULL",
    "presona_code": "NULL",
    "type_string": "станц",
    "station_name": "Хэрлэн"
  },
  {
    "syn_id": "44361",
    "id": "47492200",
    "aimag": "Ховд",
    "sum": "Манхан",
    "start_obs_date": "11/16/1962 0:00",
    "lat": "47.4194",
    "lon": "92.2239",
    "hhh": "1352.8",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01474922001Манхан",
    "presona_code": "4749220",
    "type_string": "станц",
    "station_name": "Манхан"
  },
  {
    "syn_id": "44262",
    "id": "47494600",
    "aimag": "Говь-Алтай",
    "sum": "Хөхморьт",
    "start_obs_date": "1/1/1994 0:00",
    "lat": "47.3549",
    "lon": "94.5223",
    "hhh": "1445",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01474946001ХӨХМОРЬТ",
    "presona_code": "4749460",
    "type_string": "станц",
    "station_name": "Хөхморьт"
  },
  {
    "syn_id": "44281",
    "id": "47501900",
    "aimag": "Архангай",
    "sum": "Төвшрүүлэх",
    "start_obs_date": "1/1/1995 0:00",
    "lat": "47.3867",
    "lon": "101.9085",
    "hhh": "1617.8",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01475019101ТӨВШРYYЛЭХ",
    "presona_code": "4750191",
    "type_string": "станц",
    "station_name": "Төвшрүүлэх"
  },
  {
    "syn_id": "44370",
    "id": "47606300",
    "aimag": "Төв",
    "sum": "Алтанбулаг",
    "start_obs_date": "7/1/1997 0:00",
    "lat": "47.7145",
    "lon": "106.4097",
    "hhh": "1215",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01476063101Алтанбулаг",
    "presona_code": "4760631",
    "type_string": "станц",
    "station_name": "Алтанбулаг"
  },
  {
    "syn_id": "44313",
    "id": "47618600",
    "aimag": "Дорнод",
    "sum": "Халхгол",
    "start_obs_date": "1/1/1970 0:00",
    "lat": "47.6301",
    "lon": "118.6221",
    "hhh": "687.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01476186101ХАЛХГОЛ",
    "presona_code": "4761861",
    "type_string": "станц",
    "station_name": "Халхгол"
  },
  {
    "syn_id": "44219",
    "id": "47695000",
    "aimag": "Завхан",
    "sum": "Дөрвөлжин",
    "start_obs_date": "10/1/1961 0:00",
    "lat": "47.6464",
    "lon": "94.999",
    "hhh": "1391.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01476950001ДӨРВӨЛЖИН",
    "presona_code": "4769500",
    "type_string": "станц",
    "station_name": "Дөрвөлжин"
  },
  {
    "syn_id": "44290",
    "id": "47707000",
    "aimag": "Төв",
    "sum": "Зуунмод",
    "start_obs_date": "8/20/1964 0:00",
    "lat": "47.7265",
    "lon": "106.9361",
    "hhh": "1549",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01477070101Зуунмод",
    "presona_code": "4770701",
    "type_string": "станц",
    "station_name": "Зуунмод"
  },
  {
    "syn_id": "44283",
    "id": "47803500",
    "aimag": "Булган",
    "sum": "Гурванбулаг",
    "start_obs_date": "10/1/1982 0:00",
    "lat": "47.7446",
    "lon": "103.4809",
    "hhh": "1092.6",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01478035101ГУРВАНБУЛАГ",
    "presona_code": "4780351",
    "type_string": "станц",
    "station_name": "Гурванбулаг"
  },
  {
    "syn_id": "44293",
    "id": "47806600",
    "aimag": "Улаанбаатар",
    "sum": "Улаанбаатар",
    "start_obs_date": "1/1/1979 0:00",
    "lat": "47.56",
    "lon": "106.59",
    "hhh": "1306.4",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "2001 онд хаагдсан",
    "presona_register": "01478066101МОРИН-УУЛ",
    "presona_code": "4780661",
    "type_string": "станц",
    "station_name": "Морин-Уул"
  },
  {
    "syn_id": "44291",
    "id": "47806800",
    "aimag": "Улаанбаатар",
    "sum": "УБ[Буянт-Ухаа]",
    "start_obs_date": "1/31/1967 0:00",
    "lat": "47.848",
    "lon": "106.7546",
    "hhh": "1271.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01478068101БУЯНТ-УХАА",
    "presona_code": "4780681",
    "type_string": "станц",
    "station_name": "Буянт-Ухаа"
  },
  {
    "syn_id": "44249",
    "id": "47807000",
    "aimag": "Улаанбаатар",
    "sum": "УБ[Амгалан]",
    "start_obs_date": "1/1/2014 0:00",
    "lat": "NULL",
    "lon": "NULL",
    "hhh": "1315",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "1959.04-1991.12; 2014.01.01",
    "presona_register": "NULL",
    "presona_code": "NULL",
    "type_string": "станц",
    "station_name": "Амгалан"
  },
  {
    "syn_id": "44296",
    "id": "47808400",
    "aimag": "Улаанбаатар",
    "sum": "УБ[Багануур]",
    "start_obs_date": "9/1/1990 0:00",
    "lat": "47.8065",
    "lon": "108.3389",
    "hhh": "1375",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01478084101БАГАНУУР",
    "presona_code": "4780841",
    "type_string": "станц",
    "station_name": "Багануур"
  },
  {
    "syn_id": "44302",
    "id": "47812100",
    "aimag": "Хэнтий",
    "sum": "Баян-Овоо",
    "start_obs_date": "1/1/1962 0:00",
    "lat": "47.7859",
    "lon": "112.1106",
    "hhh": "927",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01478121101БАЯН-ОВОО",
    "presona_code": "4781211",
    "type_string": "станц",
    "station_name": "Баян-Овоо"
  },
  {
    "syn_id": "44261",
    "id": "47890800",
    "aimag": "Баян-Өлгий",
    "sum": "Дэлүүн",
    "start_obs_date": "12/1/1987 0:00",
    "lat": "47.8626",
    "lon": "90.69704",
    "hhh": "2150",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01478908001ДЭЛYYН",
    "presona_code": "4789080",
    "type_string": "станц",
    "station_name": "Дэлүүн"
  },
  {
    "syn_id": "44272",
    "id": "47896800",
    "aimag": "Завхан",
    "sum": "Улиастай",
    "start_obs_date": "12/1/1936 0:00",
    "lat": "47.7271",
    "lon": "96.8476",
    "hhh": "1775",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01478968001УЛИАСТАЙ",
    "presona_code": "4789680",
    "type_string": "станц",
    "station_name": "Улиастай"
  },
  {
    "syn_id": "44297",
    "id": "47905300",
    "aimag": "Төв",
    "sum": "Лүн",
    "start_obs_date": "6/10/1964 0:00",
    "lat": "47.8671",
    "lon": "105.2507",
    "hhh": "1012",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01479053101Лүн",
    "presona_code": "4790531",
    "type_string": "станц",
    "station_name": "Лүн"
  },
  {
    "syn_id": "44226",
    "id": "47906800",
    "aimag": "Улаанбаатар",
    "sum": "УБ[Мишээл Экспо]",
    "start_obs_date": "1/1/2018 0:00",
    "lat": "47.8943",
    "lon": "106.8826",
    "hhh": "1282",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "NULL",
    "presona_code": "4790681",
    "type_string": "станц",
    "station_name": "Хан-Уул"
  },
  {
    "syn_id": "44295",
    "id": "47906900",
    "aimag": "Улаанбаатар",
    "sum": "УБ[МУИС]",
    "start_obs_date": "11/1/1982 0:00",
    "lat": "47.56",
    "lon": "106.55",
    "hhh": "1299.1",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "NULL",
    "presona_register": "01479069101ИХ СУРГУУЛЬ",
    "presona_code": "4790691",
    "type_string": "станц",
    "station_name": "Их сургууль"
  },
  {
    "syn_id": "44292",
    "id": "47907000",
    "aimag": "Улаанбаатар",
    "sum": "УБ[Сонгинохайрхан]",
    "start_obs_date": "11/15/1978 0:00",
    "lat": "47.9184",
    "lon": "106.8479",
    "hhh": "1303.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01479070101УЛААНБААТАР",
    "presona_code": "4790701",
    "type_string": "станц",
    "station_name": "Улаанбаатар"
  },
  {
    "syn_id": "44006",
    "id": "47907700",
    "aimag": "Улаанбаатар",
    "sum": "Баянзүрх",
    "start_obs_date": "1/1/1965 0:00",
    "lat": "47.52",
    "lon": "107.02",
    "hhh": "1",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "1978 оны 8 сард хаагдсан",
    "presona_register": "NULL",
    "presona_code": "NULL",
    "type_string": "станц",
    "station_name": "Хүрэлтогоот"
  },
  {
    "syn_id": "44303",
    "id": "47909800",
    "aimag": "Хэнтий",
    "sum": "Өмнөдэлгэр",
    "start_obs_date": "1/1/2013 0:00",
    "lat": "47.8922",
    "lon": "109.8022",
    "hhh": "1346",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "2013 оны 8 сараас станц болсон",
    "presona_register": "02479098101ӨМНӨДЭЛГЭР",
    "presona_code": "4790981",
    "type_string": "станц",
    "station_name": "Өмнөдэлгэр"
  },
  {
    "syn_id": "44248",
    "id": "48007500",
    "aimag": "Улаанбаатар",
    "sum": "УБ[Налайх]",
    "start_obs_date": "1/1/1986 0:00",
    "lat": "47.9887",
    "lon": "107.4566",
    "hhh": "1523",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01480075101ТЭРЭЛЖ",
    "presona_code": "4800751",
    "type_string": "станц",
    "station_name": "Тэрэлж"
  },
  {
    "syn_id": "44218",
    "id": "48091600",
    "aimag": "Ховд",
    "sum": "Ховд",
    "start_obs_date": "10/1/1936 0:00",
    "lat": "47.9959",
    "lon": "91.6324",
    "hhh": "1405",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01480916001Ховд",
    "presona_code": "4809160",
    "type_string": "станц",
    "station_name": "Ховд"
  },
  {
    "syn_id": "44259",
    "id": "48114600",
    "aimag": "Дорнод",
    "sum": "Чойбалсан",
    "start_obs_date": "1/1/1936 0:00",
    "lat": "48.11699",
    "lon": "114.50882",
    "hhh": "746",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01481146101ЧОЙБАЛСАН",
    "presona_code": "4811461",
    "type_string": "станц",
    "station_name": "Чойбалсан"
  },
  {
    "syn_id": "44364",
    "id": "48191500",
    "aimag": "Ховд",
    "sum": "Ховд",
    "start_obs_date": "4/1/1966 0:00",
    "lat": "48.1261",
    "lon": "91.3734",
    "hhh": "1711.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01481915001ДУНД-УС",
    "presona_code": "4819150",
    "type_string": "станц",
    "station_name": "Дунд-Ус"
  },
  {
    "syn_id": "44246",
    "id": "48206300",
    "aimag": "Төв",
    "sum": "Баянчандмань",
    "start_obs_date": "1/1/1968 0:00",
    "lat": "48.2276",
    "lon": "106.2854",
    "hhh": "1257.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01482063101БАЯНЧАНДМАНЬ",
    "presona_code": "4820631",
    "type_string": "станц",
    "station_name": "Баянчандмань"
  },
  {
    "syn_id": "44250",
    "id": "48208500",
    "aimag": "Төв",
    "sum": "Мөнгөнморьт",
    "start_obs_date": "7/4/1973 0:00",
    "lat": "48.2057",
    "lon": "108.4862",
    "hhh": "1429.1",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01482085101МӨНГӨНМОРЬТ",
    "presona_code": "4820851",
    "type_string": "станц",
    "station_name": "Мөнгөнморьт"
  },
  {
    "syn_id": "44229",
    "id": "48299900",
    "aimag": "Архангай",
    "sum": "Тариат",
    "start_obs_date": "1/1/1961 0:00",
    "lat": "48.1568",
    "lon": "99.8767",
    "hhh": "2059.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01482999001Тариат",
    "presona_code": "4829990",
    "type_string": "станц",
    "station_name": "Тариат"
  },
  {
    "syn_id": "44235",
    "id": "48303000",
    "aimag": "Булган",
    "sum": "Могод",
    "start_obs_date": "9/1/1974 0:00",
    "lat": "48.28007",
    "lon": "102.98",
    "hhh": "1439.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01483030101МОГОД",
    "presona_code": "4830301",
    "type_string": "станц",
    "station_name": "Могод"
  },
  {
    "syn_id": "44247",
    "id": "48305400",
    "aimag": "Төв",
    "sum": "Угтаалцайдам",
    "start_obs_date": "8/1/1974 0:00",
    "lat": "48.2586",
    "lon": "105.4042",
    "hhh": "1143",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01483054101Угтаал",
    "presona_code": "4830541",
    "type_string": "станц",
    "station_name": "Угтаал"
  },
  {
    "syn_id": "44217",
    "id": "48389500",
    "aimag": "Баян-Өлгий",
    "sum": "Алтай",
    "start_obs_date": "5/1/1964 0:00",
    "lat": "48.2993",
    "lon": "89.5149",
    "hhh": "2137",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01483895001ЯЛАЛТ",
    "presona_code": "4838950",
    "type_string": "станц",
    "station_name": "Ялалт"
  },
  {
    "syn_id": "44227",
    "id": "48395100",
    "aimag": "Завхан",
    "sum": "Завханмандал",
    "start_obs_date": "5/1/1961 0:00",
    "lat": "48.3223",
    "lon": "95.1068",
    "hhh": "1442.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01483951001ЗАВХАНМАНДАЛ",
    "presona_code": "4839510",
    "type_string": "станц",
    "station_name": "Завханмандал"
  },
  {
    "syn_id": "44237",
    "id": "48501400",
    "aimag": "Архангай",
    "sum": "Эрдэнэмандал",
    "start_obs_date": "1/1/1963 0:00",
    "lat": "48.5295",
    "lon": "101.3674",
    "hhh": "1508.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01485014101ЭРДЭНЭМАНДАЛ",
    "presona_code": "4850141",
    "type_string": "станц",
    "station_name": "Эрдэнэмандал"
  },
  {
    "syn_id": "44252",
    "id": "48505900",
    "aimag": "Төв",
    "sum": "Жаргалант",
    "start_obs_date": "2/1/1965 0:00",
    "lat": "48.5454",
    "lon": "105.882",
    "hhh": "1007",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01485059101ЖАРГАЛАНТ",
    "presona_code": "4850591",
    "type_string": "станц",
    "station_name": "Жаргалант"
  },
  {
    "syn_id": "44257",
    "id": "48610600",
    "aimag": "Хэнтий",
    "sum": "Биндэр",
    "start_obs_date": "12/9/1940 0:00",
    "lat": "48.6161",
    "lon": "110.599",
    "hhh": "1050",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01486106101БИНДЭР",
    "presona_code": "4861061",
    "type_string": "станц",
    "station_name": "Биндэр"
  },
  {
    "syn_id": "44269",
    "id": "48693000",
    "aimag": "Ховд",
    "sum": "Чандмань",
    "start_obs_date": "7/5/1963 0:00",
    "lat": "47.6642",
    "lon": "92.8125",
    "hhh": "1661.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01486930001Чандмань",
    "presona_code": "4869300",
    "type_string": "станц",
    "station_name": "Чандмань"
  },
  {
    "syn_id": "44238",
    "id": "48699400",
    "aimag": "Хөвсгөл",
    "sum": "Жаргалант",
    "start_obs_date": "11/13/1962 0:00",
    "lat": "48.58",
    "lon": "99.34692",
    "hhh": "1577.1",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "02486994001ЖАРГАЛАН",
    "presona_code": "4869940",
    "type_string": "станц",
    "station_name": "Жаргалан"
  },
  {
    "syn_id": "44224",
    "id": "48796800",
    "aimag": "Завхан",
    "sum": "Цэцэн-Уул",
    "start_obs_date": "1/1/1975 0:00",
    "lat": "48.748",
    "lon": "96.0043",
    "hhh": "1928",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01487968001ЦЭЦЭН-УУЛ",
    "presona_code": "4879680",
    "type_string": "станц",
    "station_name": "Цэцэн-Уул"
  },
  {
    "syn_id": "44225",
    "id": "48798300",
    "aimag": "Завхан",
    "sum": "Тосонцэнгэл",
    "start_obs_date": "11/4/1963 0:00",
    "lat": "48.7631",
    "lon": "98.2662",
    "hhh": "1713",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01487983001ТОСОНЦЭНГЭЛ",
    "presona_code": "4879830",
    "type_string": "станц",
    "station_name": "Тосонцэнгэл"
  },
  {
    "syn_id": "44239",
    "id": "48803600",
    "aimag": "Булган",
    "sum": "Булган",
    "start_obs_date": "1/1/1941 0:00",
    "lat": "48.8169",
    "lon": "103.517",
    "hhh": "1219.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01488036101БУЛГАН",
    "presona_code": "4880361",
    "type_string": "станц",
    "station_name": "Булган"
  },
  {
    "syn_id": "44245",
    "id": "48805000",
    "aimag": "Сэлэнгэ",
    "sum": "Орхонтуул",
    "start_obs_date": "7/15/1992 0:00",
    "lat": "48.0854",
    "lon": "104.8064",
    "hhh": "820.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01488050101ОРХОНТУУЛ",
    "presona_code": "4880501",
    "type_string": "станц",
    "station_name": "Орхонтуул"
  },
  {
    "syn_id": "44200",
    "id": "48891200",
    "aimag": "Баян-Өлгий",
    "sum": "Баяннуур",
    "start_obs_date": "5/1/1965 0:00",
    "lat": "48.9393",
    "lon": "91.1613",
    "hhh": "1333",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01488912001БАЯННУУР",
    "presona_code": "4889120",
    "type_string": "станц",
    "station_name": "Баяннуур"
  },
  {
    "syn_id": "44216",
    "id": "48893100",
    "aimag": "Увс",
    "sum": "Завхан",
    "start_obs_date": "12/1/1963 0:00",
    "lat": "48.824",
    "lon": "93.0982",
    "hhh": "1049.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01488931001ЗАВХАН",
    "presona_code": "4889310",
    "type_string": "станц",
    "station_name": "Завхан"
  },
  {
    "syn_id": "44241",
    "id": "48906100",
    "aimag": "Сэлэнгэ",
    "sum": "Баянгол",
    "start_obs_date": "12/1/1939 0:00",
    "lat": "48.9132",
    "lon": "106.0896",
    "hhh": "808.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01489061101БАРУУНХАРАА",
    "presona_code": "4890611",
    "type_string": "станц",
    "station_name": "Баруунхараа"
  },
  {
    "syn_id": "44253",
    "id": "48906900",
    "aimag": "Сэлэнгэ",
    "sum": "Мандал",
    "start_obs_date": "2/1/2001 0:00",
    "lat": "48.8605",
    "lon": "106.4431",
    "hhh": "882.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "1978 он хүртэл  2001 оны 8 сараас",
    "presona_register": "01489069101ЗYYНХАРАА",
    "presona_code": "4890691",
    "type_string": "станц",
    "station_name": "Зүүнхараа"
  },
  {
    "syn_id": "44220",
    "id": "48996800",
    "aimag": "Завхан",
    "sum": "Нөмрөг",
    "start_obs_date": "1/1/1961 0:00",
    "lat": "48.8706",
    "lon": "96.9616",
    "hhh": "1847.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01489968001НӨМРӨГ",
    "presona_code": "4899680",
    "type_string": "станц",
    "station_name": "Нөмрөг"
  },
  {
    "syn_id": "44236",
    "id": "49004100",
    "aimag": "Орхон",
    "sum": "Эрдэнэт",
    "start_obs_date": "11/1/1972 0:00",
    "lat": "49.0371",
    "lon": "104.0867",
    "hhh": "1300.1",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "\"National Agency for Meteorology",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01490041101ЭРДЭНЭТ-ОВОО",
    "presona_code": "4900411",
    "type_string": "станц",
    "station_name": "Эрдэнэт"
  },
  {
    "syn_id": "44254",
    "id": "49011600",
    "aimag": "Хэнтий",
    "sum": "Дадал",
    "start_obs_date": "3/1/1961 0:00",
    "lat": "49.0222",
    "lon": "111.6117",
    "hhh": "994",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01490116101ДАДАЛ",
    "presona_code": "4901161",
    "type_string": "станц",
    "station_name": "Дадал"
  },
  {
    "syn_id": "44214",
    "id": "49090000",
    "aimag": "Баян-Өлгий",
    "sum": "Өлгий",
    "start_obs_date": "1/1/1959 0:00",
    "lat": "48.9799",
    "lon": "89.9384",
    "hhh": "1720",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01490900001ӨЛГИЙ",
    "presona_code": "4909000",
    "type_string": "станц",
    "station_name": "Өлгий"
  },
  {
    "syn_id": "44234",
    "id": "49099600",
    "aimag": "Хөвсгөл",
    "sum": "Шинэ-Идэр",
    "start_obs_date": "11/1/1999 0:00",
    "lat": "48.950222",
    "lon": "99.5348053",
    "hhh": "1610",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01490996001ШИНЭ-ИДЭР",
    "presona_code": "4909960",
    "type_string": "станц",
    "station_name": "Шинэ-Идэр"
  },
  {
    "syn_id": "44223",
    "id": "49101400",
    "aimag": "Хөвсгөл",
    "sum": "Рашаант",
    "start_obs_date": "7/1/2001 0:00",
    "lat": "49.121",
    "lon": "101.4564",
    "hhh": "1385",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "02491014101РАШААНТ",
    "presona_code": "4910141",
    "type_string": "станц",
    "station_name": "Рашаант"
  },
  {
    "syn_id": "44215",
    "id": "49191700",
    "aimag": "Увс",
    "sum": "Өмнөговь",
    "start_obs_date": "6/1/1962 0:00",
    "lat": "49.1048",
    "lon": "91.7262",
    "hhh": "1589.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01491917001ХАР-УС",
    "presona_code": "4919170",
    "type_string": "станц",
    "station_name": "Хар-Ус"
  },
  {
    "syn_id": "44242",
    "id": "49205400",
    "aimag": "Сэлэнгэ",
    "sum": "Орхон",
    "start_obs_date": "8/11/1968 0:00",
    "lat": "49.1436",
    "lon": "105.4021",
    "hhh": "753.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01492054101ОРХОН",
    "presona_code": "4920541",
    "type_string": "станц",
    "station_name": "Орхон"
  },
  {
    "syn_id": "44002",
    "id": "49215500",
    "aimag": "Дорнод",
    "sum": "Валчингис",
    "start_obs_date": "11/1/1943 0:00",
    "lat": "49.1",
    "lon": "115.25",
    "hhh": "682.9",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "Дашбалбартай ойрхон 1956.04 хаагдсан",
    "presona_register": "NULL",
    "presona_code": "NULL",
    "type_string": "станц",
    "station_name": "Валчингис"
  },
  {
    "syn_id": "44204",
    "id": "49390900",
    "aimag": "Увс",
    "sum": "Ховд",
    "start_obs_date": "10/15/1962 0:00",
    "lat": "49.2818",
    "lon": "90.9118",
    "hhh": "1419.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "2018 оны 7 сарын 1нээс Ховд харуулын нэрийг өөрчилж станц болгосон",
    "presona_register": "02492910001????",
    "presona_code": "4939090",
    "type_string": "станц",
    "station_name": "Хөх толгой"
  },
  {
    "syn_id": "44191",
    "id": "49394800",
    "aimag": "Увс",
    "sum": "Өндөрхангай",
    "start_obs_date": "10/9/1963 0:00",
    "lat": "49.2681",
    "lon": "94.8589",
    "hhh": "1863.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01493948001ӨНДӨРХАНГАЙ",
    "presona_code": "4939480",
    "type_string": "станц",
    "station_name": "Өндөрхангай"
  },
  {
    "syn_id": "44232",
    "id": "49402700",
    "aimag": "Булган",
    "sum": "Хутаг-єндєр",
    "start_obs_date": "3/22/1961 0:00",
    "lat": "49.3936",
    "lon": "102.709",
    "hhh": "933.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01494027101ХУТАГ",
    "presona_code": "4940271",
    "type_string": "станц",
    "station_name": "Хутаг"
  },
  {
    "syn_id": "44233",
    "id": "49404000",
    "aimag": "Булган",
    "sum": "Сэлэнгэ",
    "start_obs_date": "1/1/1995 0:00",
    "lat": "49.4555",
    "lon": "103.9776",
    "hhh": "800.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01494040101ИНГЭТТОЛГОЙ",
    "presona_code": "4940401",
    "type_string": "станц",
    "station_name": "Ингэттолгой"
  },
  {
    "syn_id": "44199",
    "id": "49492600",
    "aimag": "Увс",
    "sum": "Наранбулаг",
    "start_obs_date": "6/14/1964 0:00",
    "lat": "49.3838",
    "lon": "92.5821",
    "hhh": "1143.1",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "2018 оны 7 сараас станц болсон",
    "presona_register": "01494926001НАРАНБУЛАГ",
    "presona_code": "4949260",
    "type_string": "станц",
    "station_name": "Наранбулаг"
  },
  {
    "syn_id": "44244",
    "id": "49505900",
    "aimag": "Дархан-Уул",
    "sum": "Дархан",
    "start_obs_date": "1/1/1984 0:00",
    "lat": "49.4902",
    "lon": "105.9398",
    "hhh": "917.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01495059101ДАРХАН",
    "presona_code": "4950591",
    "type_string": "станц",
    "station_name": "Дархан"
  },
  {
    "syn_id": "NULL",
    "id": "49514300",
    "aimag": "Дорнод",
    "sum": "Чулуунхороот",
    "start_obs_date": "6/1/1956 0:00",
    "lat": "49.43",
    "lon": "114.21",
    "hhh": "NULL",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "Дашбалбартай ойрхон 1961.05 хаагдсан",
    "presona_register": "NULL",
    "presona_code": "NULL",
    "type_string": "станц",
    "station_name": "Чулуунхороот"
  },
  {
    "syn_id": "44231",
    "id": "49600200",
    "aimag": "Хөвсгөл",
    "sum": "Мөрөн",
    "start_obs_date": "9/1/1939 0:00",
    "lat": "49.6384",
    "lon": "100.167",
    "hhh": "1291",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01496002101МӨРӨН",
    "presona_code": "4960021",
    "type_string": "станц",
    "station_name": "Мөрөн"
  },
  {
    "syn_id": "44230",
    "id": "49602000",
    "aimag": "Хөвсгөл",
    "sum": "Тариалан",
    "start_obs_date": "10/1/1962 0:00",
    "lat": "49.6093",
    "lon": "101.9847",
    "hhh": "1217.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01496020101ТАРИАЛАН",
    "presona_code": "4960201",
    "type_string": "станц",
    "station_name": "Тариалан"
  },
  {
    "syn_id": "44256",
    "id": "49614400",
    "aimag": "Дорнод",
    "sum": "Дашбалбар",
    "start_obs_date": "10/1/1963 0:00",
    "lat": "49.5509",
    "lon": "114.4042",
    "hhh": "706.9",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01496144101ДАШБАЛБАР",
    "presona_code": "4961441",
    "type_string": "станц",
    "station_name": "Дашбалбар"
  },
  {
    "syn_id": "44210",
    "id": "49690400",
    "aimag": "Баян-Өлгий",
    "sum": "Ногооннуур",
    "start_obs_date": "7/26/1963 0:00",
    "lat": "49.6153",
    "lon": "90.2433",
    "hhh": "1474",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-9",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01496904001НОГООННУУР",
    "presona_code": "4969040",
    "type_string": "станц",
    "station_name": "Ногооннуур"
  },
  {
    "syn_id": "44213",
    "id": "49694400",
    "aimag": "Увс",
    "sum": "Баруунтуруун",
    "start_obs_date": "7/1/1960 0:00",
    "lat": "49.6585",
    "lon": "94.4041",
    "hhh": "1234.2",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01496944001БАРУУНТУРУУН",
    "presona_code": "4969440",
    "type_string": "станц",
    "station_name": "Баруунтуруун"
  },
  {
    "syn_id": "44222",
    "id": "49697800",
    "aimag": "Хөвсгөл",
    "sum": "Цэцэрлэг",
    "start_obs_date": "8/16/1962 0:00",
    "lat": "49.5221",
    "lon": "97.73443",
    "hhh": "1744.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01496978001ЧАНДАГАТ",
    "presona_code": "4969780",
    "type_string": "станц",
    "station_name": "Чандагат"
  },
  {
    "syn_id": "44255",
    "id": "49712700",
    "aimag": "Дорнод",
    "sum": "Баян-Уул",
    "start_obs_date": "11/1/1994 0:00",
    "lat": "49.1141",
    "lon": "112.6581",
    "hhh": "894.6",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01497127101ОНОН",
    "presona_code": "4971271",
    "type_string": "станц",
    "station_name": "Онон"
  },
  {
    "syn_id": "44201",
    "id": "49793300",
    "aimag": "Увс",
    "sum": "Малчин",
    "start_obs_date": "9/11/1963 0:00",
    "lat": "49.7289",
    "lon": "93.2702",
    "hhh": "1393.6",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01497933001МАЛЧИН",
    "presona_code": "4979330",
    "type_string": "станц",
    "station_name": "Малчин"
  },
  {
    "syn_id": "44221",
    "id": "49796400",
    "aimag": "Завхан",
    "sum": "Баянтэс",
    "start_obs_date": "1/1/1962 0:00",
    "lat": "49.7005",
    "lon": "96.3633",
    "hhh": "1420.3",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01497964001БАЯН-УУЛ",
    "presona_code": "4979640",
    "type_string": "станц",
    "station_name": "Баян-Уул"
  },
  {
    "syn_id": "44251",
    "id": "49806500",
    "aimag": "Дархан-Уул",
    "sum": "Шарын гол",
    "start_obs_date": "1/1/1996 0:00",
    "lat": "49.2446",
    "lon": "106.4118",
    "hhh": "917.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01498065101ШААЗГАЙТ",
    "presona_code": "4980651",
    "type_string": "станц",
    "station_name": "Шаазгайт"
  },
  {
    "syn_id": "44243",
    "id": "49806700",
    "aimag": "Сэлэнгэ",
    "sum": "Ерөө",
    "start_obs_date": "8/30/1960 0:00",
    "lat": "49.7492",
    "lon": "106.6611",
    "hhh": "674.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC-8",
    "Supervising_org": "National Agency for Meteorology and Environment of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01498067101ЕРӨӨ",
    "presona_code": "4980671",
    "type_string": "станц",
    "station_name": "Ерөө"
  },
  {
    "syn_id": "44212",
    "id": "49892100",
    "aimag": "Увс",
    "sum": "Улаангом",
    "start_obs_date": "12/25/1942 0:00",
    "lat": "49.9714",
    "lon": "92.0778",
    "hhh": "939.1",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01498921001УЛААНГОМ",
    "presona_code": "4989210",
    "type_string": "станц",
    "station_name": "Улаангом"
  },
  {
    "syn_id": "44205",
    "id": "50002600",
    "aimag": "Булган",
    "sum": "Тэшиг",
    "start_obs_date": "7/1/2000 0:00",
    "lat": "49.9355",
    "lon": "102.6671",
    "hhh": "1019",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "02500026101ТЭШИГ",
    "presona_code": "5000261",
    "type_string": "станц",
    "station_name": "Тэшиг"
  },
  {
    "syn_id": "44202",
    "id": "50101600",
    "aimag": "Хөвсгөл",
    "sum": "Эрдэнэбулган",
    "start_obs_date": "1/1/2013 0:00",
    "lat": "50.1189",
    "lon": "101.5821",
    "hhh": "1149.5",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "NULL",
    "presona_code": "NULL",
    "type_string": "станц",
    "station_name": "Эрдэнэбулган"
  },
  {
    "syn_id": "44005",
    "id": "50106200",
    "aimag": "Сэлэнгэ",
    "sum": "Шаамар",
    "start_obs_date": "6/1/1955 0:00",
    "lat": "50.07",
    "lon": "106.11",
    "hhh": "611.8",
    "wmo_region": "NULL",
    "WIGOSCenter": "NULL",
    "Country": "NULL",
    "Time_zone": "NULL",
    "Supervising_org": "NULL",
    "type_num": "1",
    "status_string": "хаагдсан",
    "status": "0",
    "comment": "1968.06 хаагдсан",
    "presona_register": "NULL",
    "presona_code": "NULL",
    "type_string": "станц",
    "station_name": "Шаамар"
  },
  {
    "syn_id": "44240",
    "id": "50206200",
    "aimag": "Сэлэнгэ",
    "sum": "Сүхбаатар",
    "start_obs_date": "10/8/1965 0:00",
    "lat": "50.243",
    "lon": "106.1727",
    "hhh": "628.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01502062101СYХБААТАР",
    "presona_code": "5020621",
    "type_string": "станц",
    "station_name": "Сүхбаатар"
  },
  {
    "syn_id": "44206",
    "id": "50299000",
    "aimag": "Хөвсгөл",
    "sum": "Баянзүрх",
    "start_obs_date": "12/1/1975 0:00",
    "lat": "50.1787",
    "lon": "98.97552",
    "hhh": "1631.6",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "02502990001БАЯНЗYРХ",
    "presona_code": "5029900",
    "type_string": "станц",
    "station_name": "Баянзүрх"
  },
  {
    "syn_id": "44209",
    "id": "50303000",
    "aimag": "Сэлэнгэ",
    "sum": "Цагааннуур",
    "start_obs_date": "9/25/1991 0:00",
    "lat": "50.1106",
    "lon": "105.4519",
    "hhh": "784.6",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01503030101ЦАГААННУУР",
    "presona_code": "5030301",
    "type_string": "станц",
    "station_name": "Цагааннуур"
  },
  {
    "syn_id": "44207",
    "id": "50400200",
    "aimag": "Хөвсгөл",
    "sum": "Хатгал",
    "start_obs_date": "10/25/1962 0:00",
    "lat": "50.4395",
    "lon": "100.1509",
    "hhh": "1666.4",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01504002101ХАТГАЛ",
    "presona_code": "5040021",
    "type_string": "станц",
    "station_name": "Хатгал"
  },
  {
    "syn_id": "44208",
    "id": "50500500",
    "aimag": "Хөвсгөл",
    "sum": "Цагаан-Үүр",
    "start_obs_date": "1/10/1962 0:00",
    "lat": "50.5522",
    "lon": "101.5153",
    "hhh": "1140",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+8",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01505005101ЦАГААН-YYР",
    "presona_code": "5050051",
    "type_string": "станц",
    "station_name": "Цагаан-Үүр"
  },
  {
    "syn_id": "44211",
    "id": "50593600",
    "aimag": "Увс",
    "sum": "Тэс",
    "start_obs_date": "10/7/1965 0:00",
    "lat": "50.4784",
    "lon": "93.5995",
    "hhh": "799.7",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "UTC+7",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01505936001ТЭС",
    "presona_code": "5059360",
    "type_string": "станц",
    "station_name": "Тэс"
  },
  {
    "syn_id": "44203",
    "id": "51199700",
    "aimag": "Хөвсгөл",
    "sum": "Ренчинлхүмбэ",
    "start_obs_date": "10/1/1973 0:00",
    "lat": "51.1142",
    "lon": "99.6668",
    "hhh": "1582.2",
    "wmo_region": "Asia",
    "WIGOSCenter": "\"Beijing (January-June),Tokyo (July-December)\"",
    "Country": "Mongolia",
    "Time_zone": "NULL",
    "Supervising_org": "National Agency for Meteorology and Environment Monitoring of Mongolia",
    "type_num": "1",
    "status_string": "ажиллаж байгаа",
    "status": "1",
    "comment": "NULL",
    "presona_register": "01511997001РЕНЧИНЛХYМБЭ",
    "presona_code": "5119970",
    "type_string": "станц",
    "station_name": "Ренчинлхүмбэ"
  }
]

const Map=(props)=>{

    const [center, setCenter] = useState({ lat: 47.084622, lng: 104.248357 });
    const [modal, setModal] = useState(false);
    const [singleData, setSingleData] = useState({});
    
    const openModal=(e)=>{
        setSingleData(e)
        setModal(true)
    }
    const option =[]
    data.map(el=>{
        option.push({
                value: el.id,
                label: `${el.aimag},${el.sum}`
        })
    })

    const onChangeHandler=(e)=>{
        const dd = data.filter(el=>el.id==e)
        if(dd.length>0){
            setSingleData(dd[0])
        }
    }
    useEffect(()=>{
      setModal(props.visible)
    },[props.visible])
    
    const onChange=(e)=>{
      setModal(e)
      props.onChange(e);
    }

    var geojsonMarkerOptions = {
      radius: 5,
      fillColor: "#0096FF",
      color: "#000",
      weight: 1,
      opacity: 1,
      fillOpacity: 1 
  };

    return(
        <div className='leaft-header relative truncate '>
        <MapContainer 
          doubleClickZoom={false}
          maxBounds={[
            [40.0, 87.0],   // South-West (өмнөд, баруун)
            [52.5, 120.0],  // North-East (хойд, зүүн)
          ]}

          attributionControl={false} className='z-0' center={center} zoom={5} maxZoom={11} minZoom={5} center={[ 46.84622, 105.048357 ]} >
            <TileLayer
            // minZoom={4}
            // maxZoom={8}
            // attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            attribution=''
            url='https://tile.openstreetmap.org/{z}/{x}/{y}.png' //"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png 'https://api.mapbox.com/v3/mapbox.satellite.json'"
            
            />
             <GeoJSON style={{
              color:'black',
              fillColor:"#fff",
              opacity:1,
              weight:1,
              fillOpacity:0.1,
             }} data={Mongolian_map}/>

            {
                (data || []).map(el=>
                    parseInt(el.lat)>0 &&  parseInt(el.lon)>0 ?
                        <CircleMarker
                            key={el.syn_id}
                            center={[el.lat, el.lon]}
                            pathOptions={geojsonMarkerOptions}
                            radius={5}
                            // fillOpacity={active === initiative.id ? 1 : 0.5}
                            eventHandlers={{
                                click: () => {
                                    openModal(el)
                                },
                              }}
                      ></CircleMarker>
                    : null
                )
            }
        </MapContainer>
        <Modal width={500} onCancel={()=>onChange(false)}  onOk={()=>onChange(false)}  open={modal} >
            <Space className='p-2' direction="vertical"  size="small">

                <Select
                    // mode="multiple"
                    // allowClear
                    className='w-full text-sm outline-none rounded-md focus:ring-2 m-0 p-0 cursor-pointer'
                    placeholder="Сумын нэр сонгох"
                    options={option}
                    onChange={(e)=>onChangeHandler(e)}
                />
                 <Space direction="horizontal"  size="small">
                    Нэр:<Tag color='blue' className='uppercase'>{singleData.station_name}</Tag>
                </Space>

                <Space direction="horizontal"  size="small">
                    Ажиглалт эхлсэн хугацаа:<Tag className='uppercase' color='blue'>{dayjs(singleData.start_obs_date).format("YYYY-MM-DD")}</Tag>
                </Space>
                <Space direction="horizontal"  size="small">
                    Бүс нутгийн төв WIGOS:<Tag className='uppercase' color='blue'>{singleData.WIGOSCenter}</Tag>
                </Space>
                <Space direction="horizontal"  size="small">
                   Станцын төрөл:<Tag className='uppercase' color='blue'>{singleData.type_string}</Tag>
                </Space>
                <Space direction="horizontal"  size="small">
                   WMO бүс:<Tag className='uppercase' color='blue'>{singleData.wmo_region}</Tag>
                </Space>
                <Space direction="horizontal"  size="small">
                  Улс:<Tag className='uppercase' color='blue'>{singleData.country || 'Mongolia'}</Tag>
              </Space>

                 <Space direction="horizontal"  size="small">
                   Координатууд:<Tag className='uppercase' color='blue'>{`${singleData.lat}°N, ${singleData.lon}°E, ${singleData.hhh}m`}</Tag>
                </Space>

                <Space direction="horizontal"  size="small">
                    Аймаг:<Tag className='uppercase' color='blue'>{singleData.aimag}</Tag>
                </Space>
                <Space direction="horizontal"  size="small">
                    Сум:<Tag className='uppercase' color='blue'>{singleData.sum}</Tag>
                </Space>
            
                <Space direction="horizontal"  size="small">
                    Мэдээлэл:<Tag className='uppercase' color='blue'>{singleData.comment || ''}</Tag>
                </Space>
            </Space>

        </Modal>
        <Row className='absolute top-0 left-0 z-10 ml-12 mt-2'>
            <Col><Tag className='text-xs lg:text-lg' color='blue'>Цаг уурын ажиглалтын станцын байршил.</Tag></Col>
            <Col><Tag className='text-xs lg:text-lg' color='red'>Тухайн станцын мэдээллийг авахдаа газрын зураг дээрх цэг дээр дарж авна уу.</Tag></Col>
         </Row>
        </div>
    )

}

export default Map